
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/thong-ke-theo-luot-truy-cap",
      function () {
        return require("private-next-pages/admin/thong-ke-theo-luot-truy-cap/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/thong-ke-theo-luot-truy-cap"])
      });
    }
  